<template>
  <div>
    <page-header>
      <div>
        <h1>Buy {{ type === 'cms' ? 'Craft CMS' : 'plugin' }}</h1>

        <template v-if="!user || orgs.length === 0">
          <!-- Loading -->
        </template>
        <template v-else>
          <div class="mt-1">
            <template v-if="type === 'cms'">
              Which cart would you like to add the Craft CMS
              {{ edition }} license to?
            </template>
            <template v-else>
              Which cart would you like to add the
              <code>{{ handle }}</code> license to?
            </template>
          </div>
        </template>
      </div>
    </page-header>

    <template v-if="!user || orgs.length === 0">
      <spinner />
    </template>
    <template v-else>
      <form @submit.prevent="addToCart">
        <UserOrgRadioGroup v-model="selectedOrgId" :org-options="orgOptions" />

        <div class="mt-6">
          <btn
            type="submit"
            kind="primary"
            :disabled="loading || selectedOrgId === null"
            :loading="loading"
          >
            Add to Cart
          </btn>
        </div>
      </form>
    </template>
  </div>
</template>

<script>
  import PageHeader from '@console/components/app/PageHeader.vue';
  import {mapState} from 'vuex';
  import UserOrgRadioGroup from '@console/components/UserOrgRadioGroup.vue';

  export default {
    components: {UserOrgRadioGroup, PageHeader},
    data() {
      return {
        selectedOrgId: null,
        loading: false,
        type: 'cms',
      };
    },

    computed: {
      ...mapState({
        user: (state) => state.account.user,
        orgs: (state) => state.orgs.orgs,
      }),

      handle() {
        if (!this.type === 'plugin') {
          return null;
        }

        return this.$route.params.handle;
      },

      edition() {
        return this.$route.params.edition;
      },

      orgOptions() {
        return [
          {
            label: 'Personal',
            value: '',
            user: this.user,
          },

          ...this.orgs.map((org) => ({
            label: org.title,
            value: org.id,
            org,
          })),
        ];
      },

      selectedOrg() {
        return this.orgs.find((org) => org.id === parseInt(this.selectedOrgId));
      },
    },

    mounted() {
      let pageTitle = 'Buy Craft CMS';

      if (this.$route.name === 'buy.plugin') {
        this.type = 'plugin';
        pageTitle = 'Buy a plugin';
      }

      this.$store.commit('app/updatePageTitle', pageTitle);

      if (!this.user || this.orgs.length === 0) {
        this.addToCart();
      }
    },

    methods: {
      addToCart() {
        this.loading = true;

        let item;

        if (this.type === 'cms') {
          item = {
            type: 'cms-edition',
            edition: this.edition,
            autoRenew: true,
          };
        } else {
          item = {
            type: 'plugin-edition',
            plugin: this.handle,
            edition: this.edition,
            autoRenew: true,
          };
        }

        this.$store
          .dispatch('cart/addToCart', {
            orgId: this.selectedOrgId ? parseInt(this.selectedOrgId) : null,
            newItems: [item],
          })
          .then(() => {
            if (this.type === 'cms') {
              this.$store.dispatch(
                'app/displayNotice',
                'Craft CMS license added your cart.'
              );
            } else {
              this.$store.dispatch(
                'app/displayNotice',
                'Plugin license added your cart.'
              );
            }

            this.$router.push({
              path: this.selectedOrg
                ? '/accounts/' + this.selectedOrg.slug + '/cart'
                : '/cart',
            });
          })
          .catch((error) => {
            const message =
              error.response &&
              error.response.data &&
              error.response.data.message
                ? error.response.data.message
                : 'Couldn’t add license to cart.';
            this.$store.dispatch('app/displayError', message);
          })
          .finally(() => {
            this.loading = false;
          });
      },
    },
  };
</script>
